import { render, staticRenderFns } from "./Family.vue?vue&type=template&id=8145c776&scoped=true"
import script from "./Family.vue?vue&type=script&lang=ts"
export * from "./Family.vue?vue&type=script&lang=ts"
import style0 from "./Family.vue?vue&type=style&index=0&id=8145c776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8145c776",
  null
  
)

export default component.exports